export const PORTAL_PUBLICO_BASE_URL = `${process.env.REACT_APP_PORTAL_PUBLICO_URL}`;
